import fn_helper from "helpers/fn_helper";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom"
import Select from "react-select"

const LANG_OPTION = [
  { id: "TH", name: "Thai", icon: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Flag_of_Thailand.svg' },
  { id: "EN", name: "English", icon: 'https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_the_United_States.svg' },
]
function InputLang({
  widthfull = false,
  forceRoute = false,
  pageView = "List"
}) {
  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? 'TH'
  const navigate = useNavigate();

  const [ value, setValue ] = useState(qLang)
  // STATE DROPDOWN
  const [ langOption, setLangOption ] = useState(LANG_OPTION)
  

  const handleOnChange = (selectId) => {
    setValue(selectId)
    const pathname = window.location.pathname
    const Lang = `/${selectId}`

    // console.log({langOption})
    const langList = langOption.map((r, idx) => {
      return r.id
    })

    // console.log({langList})
    // ----- MOCK ------
    // pageView = 'List'
    // const pathname = '/highlight/th'
    // ----- MOCK ------
    console.log("🚀 ~ handleOnChange ~ pathname:", pathname)

    let redirectLink = ''
    if(['create','update','view'].includes(pageView)) {
      const ACTION_ROUTE_CONF = { 'create':'/create', 'update':'/edit', 'view':'/view' }
      let actionRoute = ''

      if (ACTION_ROUTE_CONF[pageView]) {
        actionRoute = ACTION_ROUTE_CONF[pageView]
      }

      console.log('pathname.lastIndexOf(actionRoute)', pathname.lastIndexOf(actionRoute))

      if (actionRoute) {
        if(pathname.lastIndexOf(actionRoute) > -1) {
          const mainPath = pathname.substring(0, pathname.lastIndexOf(actionRoute));
          const actionPath = pathname.substring(pathname.lastIndexOf(actionRoute));
          redirectLink = mainPath.slice(0, -3) + Lang + actionPath
        }
        else {
          console.log('pathname.lastIndexOf(`/${qLang}`)', pathname.lastIndexOf(`/${qLang}`))
          const mainPath = pathname.substring(0, pathname.lastIndexOf(`/${qLang}`));
          redirectLink = mainPath + Lang
        }
      }
    } else {
        // redirectLink = pathname.slice(0, -3) + Lang
        // console.log({redirectLink})

        let splitPath = pathname.split('/')
        const langIndex = splitPath.indexOf(qLang);
        if (~langIndex) {
          splitPath[langIndex] = selectId;
        }
        redirectLink = splitPath.join('/')
        console.log({redirectLink})
    }
    console.log("🚀 ~ handleOnChange ~ redirectLink:", redirectLink)
    if (forceRoute) {
      window.location.href = redirectLink
    } else {
      navigate(redirectLink)
    }
  }
  
  useEffect(() => {
    console.log("🚀 ~ useEffect ~ Call API set:")
    // ค่อยกลับมาทำ

  }, [])
  return (
    <>
    {/* {pageView} */}
      <Select
        className={`select2-selection dd-flag-main ${widthfull ? 'w-full' : ''} `}
        placeholder="Select Lang"
        value={fn_helper.FNFORM.getObjectValue(langOption, `${value}`)}
        onChange={(value) => {
          handleOnChange(value.value)
        }}
        options={transformedOptions(langOption)}
        components={{ 
          Option: customOption, 
          SingleValue: customSingleValue 
        }}
        isDisabled={false}
      />
    </>
  )
}

// แปลงข้อมูลจาก LANG_OPTION ให้เป็นโครงสร้างที่ react-select เข้าใจ
const transformedOptions = (option = []) => {
  let ansOption = option.map(option => {
    return { value: option.id, label: option.name, icon: option.icon,}
  })

  return ansOption;
}

// Custom Option Component สำหรับแสดงผลตัวเลือกพร้อมรูปภาพ
const customOption = (props) => {
  const { data, innerRef, innerProps } = props;
  return (
    <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center', padding: 10 }}>
      <img
        src={data.icon}
        alt={data.label}
        style={{ width: 20, height: 20, marginRight: 10 }}
      />
      <span>{data.label}</span>
    </div>
  );
};

// Custom Single Value Component เพื่อแสดงรูปภาพในค่าที่เลือก
const customSingleValue = ({ data }) => (
  <div className="dd-flag-value" style={{ display: 'flex', alignItems: 'center' }}>
    <img
      src={data.icon}
      alt={data.name}
      style={{ width: 20, height: 20, marginRight: 10 }}
    />
    <span>{data.name}</span>
  </div>
);

export default InputLang;
